import { Alignments } from 'rich-text-lib/constants/alignments';
export const IMAGE_SETTINGS = 'hsImage';
export const hsimageConfig = {
  AUTO_MAX_WIDTH: 'imageAutoMaxWidth',
  DISABLE_RESIZING_PREDICATE: 'imageDisableResizing',
  DISABLE_SPACING: 'imageDisableSpacing',
  USE_ALIGNMENT_CLASSES: 'imageUseAlignmentClasses',
  MAX_DIMENSION_WIDTH: 'imageMaxDimensionWidth',
  STRIP_IMAGE_BLOBS: 'stripImageBlobs',
  USE_CUSTOM_ALT_TEXT: 'useCustomAltText',
  HAS_IMAGE_GENERATION_TOOLBAR_BUTTON: 'hasImageGenerationToolbarButton',
  USE_IMAGE_GENERATION_SLASH_COMMAND: 'useImageGenerationSlashCommand',
  IMAGE_LOADING_DEFAULT_VALUE: 'imageLoadingDefaultValue'
};
export const STYLE_OPTIONS = {
  [Alignments.LEFT]: {
    float: 'left',
    'margin-left': '0px',
    'margin-right': '10px',
    display: null
  },
  [Alignments.CENTER]: {
    float: null,
    'margin-left': 'auto',
    'margin-right': 'auto',
    display: 'block'
  },
  [Alignments.RIGHT]: {
    float: 'right',
    'margin-left': '10px',
    'margin-right': '0px',
    display: null
  },
  [Alignments.NONE]: {
    float: null,
    'margin-left': null,
    'margin-right': null,
    display: null
  }
};
export const FileSource = {
  AI_GENERATED: 'AI_GENERATED',
  CANVA: 'CANVA',
  SHUTTERSTOCK: 'SHUTTERSTOCK'
};